import { render } from "./PaneBuildingPart.vue?vue&type=template&id=21ce94b2&scoped=true&ts=true"
import script from "./PaneBuildingPart.vue?vue&type=script&lang=ts"
export * from "./PaneBuildingPart.vue?vue&type=script&lang=ts"

import "./PaneBuildingPart.vue?vue&type=style&index=0&id=21ce94b2&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21ce94b2"]])

export default __exports__